module.exports = __webpack_public_path__ + "static/media/bg2.93d364b5.jpg";